import {makeObservable, observable, runInAction} from 'mobx';

export default class UIManager {
  public addButtonShown: boolean;
  public addModalShown: boolean;
  public editModalShown: boolean;
  public editItemModalShown: boolean;

  public previousPage: string | null;
  public needReloadItems: boolean;

  public needReloadProfile: boolean;

  public editItemId: string | null;

  // Lists (named wishlists per occasion)
  public listModalShown: boolean;
  public editListId: string | null;
  public needReloadLists: boolean;
  // uuid of the list currently open, so the add/edit item modals target it
  public currentListId: string | null;

  constructor() {
    makeObservable(this, {
      addButtonShown: observable,
      addModalShown: observable,
      editModalShown: observable,
      editItemModalShown: observable,
      previousPage: observable,
      needReloadItems: observable,
      needReloadProfile: observable,
      editItemId: observable,
      listModalShown: observable,
      editListId: observable,
      needReloadLists: observable,
      currentListId: observable,
    })
    this.addButtonShown = false;
    this.addModalShown = false;
    this.editModalShown = false;
    this.editItemModalShown = false;
    this.previousPage = null;
    this.needReloadItems = true;
    this.needReloadProfile = true;
    this.editItemId = null;
    this.listModalShown = false;
    this.editListId = null;
    this.needReloadLists = true;
    this.currentListId = null;
  }

  toggleAddButton(show: boolean) {
    runInAction(() => {
      this.addButtonShown = show;
    })
  }

  toggleAddModal(show: boolean) {
    runInAction(() => {
      this.addModalShown = show;
    })
  }

  openAddModal() {
    if (this.addModalShown) {
      return;
    }
    this.toggleAddModal(true);
  }

  toggleEditModal(show: boolean, previousPage: string | null = null) {
    runInAction(() => {
      this.editModalShown = show;
      this.previousPage = previousPage;
    })
  }

  toggleEditItemModal(show: boolean, editItemId: string | null = null) {
    runInAction(() => {
      this.editItemModalShown = show;
      this.editItemId = editItemId;
    })
  }

  toggleNeedReloadItems(reload: boolean) {
    runInAction(() => {
      this.needReloadItems = reload;
    })
  }

  toggleNeedReloadProfile(reload: boolean) {
    runInAction(() => {
      this.needReloadProfile = reload;
    })
  }

  toggleListModal(show: boolean, editListId: string | null = null) {
    runInAction(() => {
      this.listModalShown = show;
      this.editListId = editListId;
    })
  }

  toggleNeedReloadLists(reload: boolean) {
    runInAction(() => {
      this.needReloadLists = reload;
    })
  }

  setCurrentList(listId: string | null) {
    runInAction(() => {
      this.currentListId = listId;
    })
  }
}
